import Player from './Player';

// https://developers.soundcloud.com/docs/api/html5-widget#playground
export default class SoundcloudPlayer extends Player {
	static #getSCPromise = null;
	#getWidgetPromise = null;
	#iframe = null;
	#endSeconds = 0;

	constructor(elemId, apiKey) {
		super(elemId);
		this.apiKey = apiKey;
	}

	static getName() { return 'SoundCloud'; }
	static urlMatches(url) {
		return url.match(/^https?:\/\/(www\.)?soundcloud\.com\/[^/]+\/[^/]+$/);
	}

	static getSC() {
		return SoundcloudPlayer.#getSCPromise ||= new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = 'https://w.soundcloud.com/player/api.js';
			script.onerror = reject;
			script.onload = () => resolve(window.SC);
			document.head.appendChild(script);
		});
	}

	getWidget(url) {
		if(!url && !this.#getWidgetPromise)
			return Promise.reject(new ReferenceError('No URL specified'));

		return this.#getWidgetPromise ||= new Promise((resolve, reject) => {
			return SoundcloudPlayer.getSC().then(SC => {
				const container = document.getElementById(this.elemId);
				this.#iframe = document.createElement('iframe');
				this.#iframe.id = `${this.containerId}-iframe`;
				this.#iframe.allow = 'autoplay';
				this.#iframe.width = '100%';
				this.#iframe.height = '100%';
				this.#iframe.frameBorder = 'no';
				this.#iframe.src = `https://w.soundcloud.com/player/?${new URLSearchParams({ url, show_artwork: true })}`;
				container.appendChild(this.#iframe);

				console.log('getting', this.elemId);
				console.log(document.getElementById(this.elemId));
				const widget = SC.Widget(this.#iframe);
				widget.bind(SC.Widget.Events.ERROR, err => {
					console.log("GETSC ERROR", err);
					widget.unbind(SC.Widget.Events.ERROR);
					widget.unbind(SC.Widget.Events.READY);
					reject(err);
				});
				widget.bind(SC.Widget.Events.READY, () => {
					console.log("GETSC READY");
					widget.unbind(SC.Widget.Events.READY);
					widget.unbind(SC.Widget.Events.ERROR);
					widget.bind(SC.Widget.Events.FINISH, () => this.emit('status', { status: 'finished' }));
					widget.bind(SC.Widget.Events.ERROR, ev => this.emit('error', ev));
					widget.bind(SC.Widget.Events.PLAY_PROGRESS, (ev) => { console.log('progress', ev); this.emit('progress', ev); });
					widget.bind(SC.Widget.Events.PLAY, () => this.emit('status', { status: 'playing' }));
					widget.bind(SC.Widget.Events.PAUSE, () => this.emit('status', { status: 'paused' }));
					widget.bind(SC.Widget.Events.LOAD_PROGRESS, (ev) => { console.log('loadProgress', ev); this.emit('loadProgress', ev); });
					widget.bind(SC.Widget.Events.SEEK, (ev) => { console.log('seeeeek', ev); this.emit('seek', ev); });
					resolve(widget);
				});
			});
		});
	}

	async load(url, startTime, maxDuration) {
		document.getElementById(this.elemId).style.display = 'block';
		const needLoad = !!this.#getWidgetPromise;
		const widget = await this.getWidget(url);
		if(startTime) widget.seekTo(startTime);
		if(needLoad)
			widget.load(url, { auto_play: true });
		this.#endSeconds = (startTime||0) + (maxDuration||0);
	}

	async isPlaying() {
		const widget = await this.getWidget();
		return new Promise(resolve => {
			widget.isPaused(resolve);
		});
	}

	async play() {
		const widget = await this.getWidget();
		widget.play();
	}

	async pause() {
		const widget = await this.getWidget();
		widget.pause();
	}

	async togglePause() {
		const widget = await this.getWidget();
		widget.toggle();
	}

	async stop() {
		const widget = await this.getWidget();
		widget.pause();
		widget.seekTo(0);
	}

	async getCurrentTime() {
		const widget = await this.getWidget();
		return widget.getPosition();
	}

	async setVolume(vol) {
		const widget = await this.getWidget();
		widget.setVolume(vol);
	}

	async cleanup() {
		console.log('sc cleanup');
		try {
			// const widget = await this.getWidget();
			this.#iframe?.parentNode?.removeChild(this.#iframe);
			this.#getWidgetPromise = null;
			this.#iframe = null;
		} catch(e) {
			// ignore
		}
	}
}
